"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1169],{

/***/ 273174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HeaderArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var HeaderArrow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "7.561",
        height: props.height || "4.427",
        viewBox: "0 0 7.561 4.427",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "Path_296380",
            fill: props.color || "#000",
            "data-name": "Path 296380",
            d: "M145.574,181.8l-3.166-3.166a.633.633,0,0,0-.893,0L138.35,181.8a.633.633,0,0,0,.893.893l2.716-2.716,2.722,2.716a.631.631,0,1,0,.893-.893Z",
            transform: "translate(-138.197 -178.446)"
        })
    });
};


/***/ }),

/***/ 152264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header8; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/DesignSystem/NavigationItems/index.js
var NavigationItems = __webpack_require__(153987);
// EXTERNAL MODULE: ./src/redux/actions/additionalPages.js
var additionalPages = __webpack_require__(792516);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/Common/ReactHamburger/index.js + 1 modules
var ReactHamburger = __webpack_require__(70440);
// EXTERNAL MODULE: ./src/utils/isClickOutside.js
var isClickOutside = __webpack_require__(853569);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/utils/orderDropdownList.js
var orderDropdownList = __webpack_require__(20503);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/assets/svgExports/UserIconDark.js
var UserIconDark = __webpack_require__(252514);
// EXTERNAL MODULE: ./src/assets/svgExports/SearchIcon.js
var SearchIcon = __webpack_require__(350127);
;// CONCATENATED MODULE: ./src/assets/svgExports/ContactUs.js

var ContactUs = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "24.001",
        height: props.height || "24.07",
        viewBox: "0 0 15.001 15.07",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "whatsapp-9",
            d: "M12.858,2.155A7.35,7.35,0,0,0,1.293,11.022L.25,14.83l3.9-1.022a7.341,7.341,0,0,0,3.512.894h0a7.352,7.352,0,0,0,5.2-12.547ZM7.66,13.461h0a6.1,6.1,0,0,1-3.109-.851l-.223-.132-2.312.606.617-2.254L2.486,10.6A6.108,6.108,0,1,1,7.66,13.461Zm3.35-4.574c-.184-.092-1.086-.536-1.255-.6s-.291-.092-.413.092-.474.6-.581.72-.214.138-.4.046a5.015,5.015,0,0,1-1.477-.911A5.539,5.539,0,0,1,5.865,6.964c-.107-.184,0-.274.081-.375a5.194,5.194,0,0,0,.459-.628.338.338,0,0,0-.015-.322c-.046-.092-.413-1-.566-1.363s-.3-.31-.413-.315-.229-.006-.352-.006a.674.674,0,0,0-.49.23,2.059,2.059,0,0,0-.643,1.532,3.572,3.572,0,0,0,.75,1.9,8.185,8.185,0,0,0,3.137,2.772,10.51,10.51,0,0,0,1.047.387,2.517,2.517,0,0,0,1.156.073,1.892,1.892,0,0,0,1.239-.873,1.534,1.534,0,0,0,.107-.873C11.317,9.025,11.194,8.979,11.011,8.887Zm0,0",
            transform: "translate(-0.108 0.1)",
            stroke: "#fff",
            strokeWidth: "0.2",
            fillRule: "evenodd"
        })
    });
};

;// CONCATENATED MODULE: ./src/assets/svgExports/HeaderShoppingCart.js

var HeaderShoppingCart = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "15.228",
        height: props.height || "15.603",
        viewBox: "0 0 15.228 15.603",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "shopping-cart-10",
            transform: "translate(0.075 0.075)",
            opacity: "0.997",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path_296381",
                    fill: props.color || "#000",
                    "data-name": "Path 296381",
                    d: "M14.625,2.625a1.927,1.927,0,0,0-1.483-.693H2.731L2.7,1.706A1.932,1.932,0,0,0,.787,0H.644a.644.644,0,0,0,0,1.288H.787a.644.644,0,0,1,.639.568L2.312,9.39a3.219,3.219,0,0,0,3.2,2.844h6.724a.644.644,0,1,0,0-1.288H5.51A1.932,1.932,0,0,1,3.694,9.658h7.675A3.219,3.219,0,0,0,14.538,7.01l.505-2.8a1.928,1.928,0,0,0-.419-1.581Zm-.845,1.353-.506,2.8a1.932,1.932,0,0,1-1.9,1.589H3.489L2.883,3.219H13.142a.644.644,0,0,1,.637.758Z",
                    stroke: "#fff",
                    strokeWidth: "0.15"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_5154",
                    fill: props.color || "#000",
                    "data-name": "Ellipse 5154",
                    cx: "1.288",
                    cy: "1.288",
                    r: "1.288",
                    transform: "translate(3.219 12.878)",
                    stroke: "#fff",
                    strokeWidth: "0.15"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    id: "Ellipse_5155",
                    fill: props.color || "#000",
                    "data-name": "Ellipse 5155",
                    cx: "1.288",
                    cy: "1.288",
                    r: "1.288",
                    transform: "translate(9.658 12.878)",
                    stroke: "#fff",
                    strokeWidth: "0.15"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/assets/svgExports/HeaderArrow.js
var HeaderArrow = __webpack_require__(273174);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./src/hooks/useSaveHeaderHeight.js
var useSaveHeaderHeight = __webpack_require__(953395);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/logoAndNameHelpers.ts
var logoAndNameHelpers = __webpack_require__(273494);
// EXTERNAL MODULE: ./src/components/InstallAppInstructionsOverlay/useInstallAppOverlayActions.tsx
var useInstallAppOverlayActions = __webpack_require__(141771);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/getActualOrDsStoreLogo.js
var getActualOrDsStoreLogo = __webpack_require__(168491);
// EXTERNAL MODULE: ./src/utils/checkIfWebview.js
var checkIfWebview = __webpack_require__(493326);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(704956);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
// EXTERNAL MODULE: ./src/utils/getWhatsAppRedirectionUrl.js
var getWhatsAppRedirectionUrl = __webpack_require__(230066);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Header/utils.tsx + 2 modules
var utils = __webpack_require__(545588);
// EXTERNAL MODULE: ./src/assets/svgExports/WishlistHeartIcon.js + 1 modules
var WishlistHeartIcon = __webpack_require__(407056);
// EXTERNAL MODULE: ./src/utils/isWishlistUnlockedAndActive.js
var isWishlistUnlockedAndActive = __webpack_require__(291529);
// EXTERNAL MODULE: ./src/utils/useCheckIfHomePage.ts
var useCheckIfHomePage = __webpack_require__(576609);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/Header8/index.js






































var InstallAppInstructionsOverlay = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 557).then(__webpack_require__.bind(__webpack_require__, 700557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(700557)
            ];
        }
    },
    ssr: false
});
var MegaMenuDesktopView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6065).then(__webpack_require__.bind(__webpack_require__, 546065)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546065)
            ];
        }
    },
    ssr: false
});
var Header = function(props) {
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDesktopDropdown(!showDesktopDropdown);
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderHeaderIcons = function renderHeaderIcons(icon) {
        switch(icon.name){
            case "Wishlist":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        className: "pointer mr30px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartIcon/* default */.Z, {
                            color: "black",
                            iconSize: 18
                        })
                    });
                }
            case "Search":
                {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        className: "pointer mr30px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                            width: "15",
                            height: "15",
                            color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.primary_color
                        })
                    });
                }
            case "Contact Us":
                {
                    var ref1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        className: "pointer mr30px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs, {
                            width: "15",
                            height: "15",
                            color: storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.primary_color
                        })
                    });
                }
            case "Cart":
                {
                    var ref2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        className: "pointer mr30px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderShoppingCart, {
                            width: 15,
                            height: 15,
                            color: storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.primary_color
                        })
                    });
                }
            case "orders":
                {
                    var ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        className: "pointer mr6px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                            width: "22",
                            height: "22",
                            color: storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.primary_color
                        })
                    });
                }
        }
    };
    var renderMobileLoginLogout = function renderMobileLoginLogout() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobile-login-navigation-container flex " + ((user === null || user === void 0 ? void 0 : user.isLogin) ? "red" : null),
                onClick: toggleAuthModal,
                children: [
                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr10px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                            color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff",
                            width: "18",
                            height: "18"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: 1,
                            marginLeft: 5
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                ]
            })
        });
    };
    var renderCustomNavigationItems = function renderCustomNavigationItems() {
        return TempIconList.map(function(icon) {
            var showIcon = icon.name !== "Contact Us" || !!storePhone;
            return showIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "relative f6 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pointer pr10px",
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        children: isDesktop && icon.name !== "orders" && icon.name
                    }),
                    isDesktop ? renderHeaderIcons(icon) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: icon.imgSrc,
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        }
                    })
                ]
            }, icon.name);
        });
    };
    var renderNavigationItems = function renderNavigationItems() {
        return IconList.map(function(icon) {
            if (!(icon === null || icon === void 0 ? void 0 : icon.isVisible)) {
                return;
            }
            var showIcon = icon.name !== "Contact Us" || !!storePhone;
            return showIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "relative f6 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pointer pr10px",
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        children: isDesktop && icon.name !== "orders" && icon.name
                    }),
                    isDesktop ? renderHeaderIcons(icon) : (icon === null || icon === void 0 ? void 0 : icon.name) === "Wishlist" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        className: "tw-ml-[22px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartIcon/* default */.Z, {
                            iconSize: 25,
                            color: "black"
                        })
                    }) : icon.imgSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: icon.imgSrc,
                        onClick: function() {
                            return onHandlePageClick(icon.href);
                        },
                        style: icon.name === "search" ? {
                            filter: "brightness(0)"
                        } : {}
                    }),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "br2 absolute z-5 header-8-orderdropdown-container" + (isVisitorLoginVisible ? "" : "-nologin"),
                        children: showDesktopDropdown && icon.name === "orders" && ordersDropdownList.map(function(item) {
                            var ref;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    item.id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "header-8-orderdropdown-container-arrow"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "header-8-orderdropdown-item flex items-center z-5 " + (item.id === 3 ? "red " : "") + (item.id !== 1 && "pointer"),
                                        onClick: function(e) {
                                            return onHandleOrdersDropdown(item, e);
                                        },
                                        children: [
                                            item.id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr3 mt1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                                                    color: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.primary_color,
                                                    width: "33",
                                                    height: "33"
                                                })
                                            }),
                                            item.name
                                        ]
                                    })
                                ]
                            }, item.id);
                        })
                    }),
                    icon.name === "Cart" && (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "cart-item-length-comp absolute",
                        children: items.length
                    })
                ]
            }, icon.name);
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var _showCategories = props.showCategories, showCategories = _showCategories === void 0 ? false : _showCategories;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref5 = (0,react.useState)(false), isOpen = ref5[0], setOpen = ref5[1];
    var openIntallAppOverlay = (0,useInstallAppOverlayActions/* default */.Z)().openIntallAppOverlay;
    var isWebview = (0,checkIfWebview/* default */.Z)();
    var ref6 = (0,react.useState)(false), showLogoutConfirmation = ref6[0], setShowLogoutConfirmation = ref6[1];
    var ref7 = (0,react.useState)(false), showDesktopDropdown = ref7[0], setShowDesktopDropdown = ref7[1];
    var ref8 = (0,react.useState)(false), showMegaMenu = ref8[0], setShowMegaMenu = ref8[1];
    var isHomePage = (0,useCheckIfHomePage/* useCheckIfHomePage */.t)();
    var ref9 = (0,es/* useSelector */.v9)(function(state) {
        return {
            items: state.cartReducer.items,
            user: state.userReducer
        };
    }), items = ref9.items, user = ref9.user;
    var ref10 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList,
            catalogCategories: state.catalogReducer.categories,
            productTags: state.catalogReducer.productTags
        };
    }), storeData = ref10.storeData, navigationList = ref10.navigationList, catalogCategories = ref10.catalogCategories, productTags = ref10.productTags;
    var ref11 = (0,react.useRef)();
    var headerRef = (0,react.useRef)();
    (0,useSaveHeaderHeight/* default */.Z)(headerRef);
    var ref12 = (0,useFeatureLocks/* useFeatureLocks */.r)(), visitorLoginFeatureStatus = ref12.visitorLoginFeatureStatus, installAppFeatureStatus = ref12.installAppFeatureStatus;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(storeData);
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var IconList = [
        {
            name: "Search",
            imgSrc: "/assets/icons/search.svg",
            href: routes.PATH.SEARCH,
            isVisible: true
        },
        {
            name: "Contact Us",
            imgSrc: "/assets/icons/whatsapp.svg",
            href: false,
            isVisible: true
        },
        {
            name: "Wishlist",
            imgSrc: "WishlistHeartIcon",
            href: routes.PATH.WISHLIST,
            isVisible: (0,isWishlistUnlockedAndActive/* isWishlistUnlockedAndActive */.r)() ? true : false
        },
        {
            name: "Cart",
            imgSrc: "/assets/icons/shopping-cart.svg",
            href: routes.PATH.CART,
            isVisible: !(0,utils/* isWebFrameRoute */.RA)()
        },
        {
            name: "orders",
            imgSrc: "",
            href: routes.PATH.ORDERS,
            isVisible: true
        }, 
    ];
    var TempIconList = [
        {
            name: "Contact Us",
            imgSrc: "/assets/icons/whatsapp.svg",
            href: false
        }, 
    ];
    var ordersDropdownList = (0,orderDropdownList/* default */.Z)();
    var isDesktop = deviceWidth/* deviceWidth */.o > 766 ? true : false;
    if (isDesktop) IconList.splice(1, 1);
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var callback = function() {
            return setShowDesktopDropdown(false);
        };
        (0,isClickOutside/* commonOutsideClick */.C)({
            event: e,
            pathNo: 1,
            ref: ref11,
            callback: callback
        });
    };
    (0,react.useEffect)(function() {
        setOpen(false);
        setShowLogoutConfirmation(false);
    }, [
        user.isLogin
    ]);
    (0,react.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(navigationList === null || navigationList === void 0 ? void 0 : navigationList.length)) {
            dispatch((0,additionalPages/* getNavigationPagesList */.A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        navigationList
    ]);
    (0,react.useEffect)(function() {
        if (isOpen) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "auto";
        }
    }, [
        isOpen
    ]);
    var onHandlePageClick = function(href) {
        if (href === routes.PATH.CART && (0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B) {
            dispatch((0,storeInfo/* toggleRfqFormModal */.H4)());
            return;
        }
        if ((user === null || user === void 0 ? void 0 : user.isLogin) && href === routes.PATH.ORDERS && isDesktop) {
            toggleShowDesktopDropdown();
        } else if (href) {
            var ref;
            router_default().push((0,routes.getRoute)(href, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        } else {
            (0,getWhatsAppRedirectionUrl/* openWhatsAppLeadModal */.iM)();
        }
    };
    var onHandleOrdersDropdown = function(item) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        switch(item.action){
            case constants/* ORDERS_DROPDOWN_LIST.MY_ORDERS */.Bm.MY_ORDERS:
                {
                    var ref;
                    toggleShowDesktopDropdown();
                    router_default().push((0,routes.getRoute)(routes.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                    break;
                }
            case constants/* ORDERS_DROPDOWN_LIST.LOGOUT */.Bm.LOGOUT:
                {
                    toggleLogoutModal();
                    break;
                }
            case constants/* ORDERS_DROPDOWN_LIST.DEFAULT_PHONE */.Bm.DEFAULT_PHONE:
                {
                    break;
                }
            default:
                {
                    break;
                }
        }
    };
    var toggleAuthModal = function() {
        if (user === null || user === void 0 ? void 0 : user.isLogin) {
            toggleLogoutModal();
        } else {
            var ref;
            router_default().push((0,routes.getRoute)(routes.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var Wrapper = isHomePage ? "h1" : "div";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: headerRef,
        className: "Header8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Header8__inner",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "Header8__inner--subsection",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "Header8__desktop Header8__name-logo-container",
                                children: [
                                    storeLogo && (0,logoAndNameHelpers/* getVisibilityForHeader */.g)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.store_logo_status) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                                        style: {
                                            margin: 0,
                                            fontWeight: "inherit",
                                            fontSize: "inherit"
                                        },
                                        children: [
                                            isHomePage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                class: "visually-hidden",
                                                children: storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "store-logo pointer",
                                                src: storeLogo,
                                                alt: "store logo",
                                                onClick: function() {
                                                    (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : storeData.domain);
                                                }
                                            })
                                        ]
                                    }),
                                    (0,logoAndNameHelpers/* getVisibilityForHeader */.g)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.store_name_status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "store-name pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : storeData.domain);
                                            },
                                            children: storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.store_info) === null || ref3 === void 0 ? void 0 : ref3.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "Header8__mobile",
                                style: {
                                    marginLeft: -10
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHamburger["default"], {
                                        open: isOpen,
                                        setOpen: setOpen,
                                        theme: "#000000"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "Header8__desktop",
                                children: (navigationList === null || navigationList === void 0 ? void 0 : navigationList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItems/* default */.Z, {
                                    categories: (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(catalogCategories)) || [],
                                    navigationItems: navigationList || [],
                                    showCategories: showCategories,
                                    toggleMegaMenu: function() {
                                        return setShowMegaMenu(!showMegaMenu);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: ref11,
                        className: "Header8__inner--subsection",
                        children: [
                            showCategories ? renderCustomNavigationItems() : renderNavigationItems(),
                            isDesktop && !showCategories && (user === null || user === void 0 ? void 0 : user.isLogin) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "header-8-arrowsvg pointer " + (showDesktopDropdown ? "" : "rotate-180"),
                                onClick: toggleShowDesktopDropdown,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderArrow/* HeaderArrow */.i, {
                                    color: storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.theme) === null || ref4 === void 0 ? void 0 : ref4.primary_color,
                                    width: "10",
                                    height: "10"
                                })
                            })
                        ]
                    })
                ]
            }),
            showMegaMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuDesktopView, {
                open: showMegaMenu,
                onClose: function() {
                    return setShowMegaMenu(false);
                }
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Header8__mobile navigation__container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "navigation__container--inner",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItems/* default */.Z, {
                            categories: (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(catalogCategories)) || [],
                            navigationItems: navigationList || [],
                            closeNavigationOnMobile: function() {
                                return setOpen(false);
                            },
                            showCategories: showCategories
                        }),
                        !isWebview && !showCategories && (installAppFeatureStatus === null || installAppFeatureStatus === void 0 ? void 0 : installAppFeatureStatus.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pwa:tw-hidden",
                            onClick: function() {
                                openIntallAppOverlay();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    marginLeft: 32,
                                    marginBottom: 30
                                },
                                children: "Install App"
                            })
                        }),
                        isVisitorLoginVisible && !showCategories && !(0,getNavList/* showMyAccount */.p6)() && renderMobileLoginLogout()
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallAppInstructionsOverlay, {}),
            !showCategories && showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        ]
    });
};
/* harmony default export */ var Header8 = (Header);


/***/ }),

/***/ 493326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(506337);

var checkIfWebview = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6 && !!window.ReactNativeWebView;
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfWebview);


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 853569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ commonOutsideClick; },
/* harmony export */   "W": function() { return /* binding */ isOutsideClick; }
/* harmony export */ });
var isOutsideClick = function(parentRef, target) {
    var ref;
    if ((ref = parentRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) return true;
    return false;
};
var commonOutsideClick = function(param) {
    var event = param.event, _pathNo = param.pathNo, pathNo = _pathNo === void 0 ? 0 : _pathNo, ref = param.ref, callback = param.callback;
    var path = event.path || event.composedPath && event.composedPath();
    if (!isOutsideClick(ref, path[pathNo])) {
        callback && callback();
    }
};


/***/ }),

/***/ 291529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ isWishlistUnlockedAndActive; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var src_constants_wishlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(298627);


function isWishlistUnlockedAndActive() {
    var ref, ref1, ref2, ref3;
    var stateData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState();
    var isWishlistEnabled = stateData === null || stateData === void 0 ? void 0 : (ref = stateData.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag;
    var isWishlistSubscribed = (ref3 = stateData === null || stateData === void 0 ? void 0 : stateData.commonReducer.featureLocksData.featureLocks) === null || ref3 === void 0 ? void 0 : ref3.wishlist;
    return isWishlistEnabled === src_constants_wishlist__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE && !(isWishlistSubscribed === null || isWishlistSubscribed === void 0 ? void 0 : isWishlistSubscribed.isLocked);
}


/***/ })

}]);